export default {
  _Lang: "Dutch",
  MomentLang: "nl",

  Account: {
    AccountPermissions: "Accountrechten",
    AllDisabled: "Allemaal uitgeschakeld",
    AllEnabled: "Allemaal ingeschakeld",
    DeleteProfile: "Verwijder gebruiker",
    DeleteUserGroupError: "Delete Group Error",
    EditInformation: "Informatie bewerken",
    GlobalPreset: "Global Preset",
    GlobalPresetModalMessage:
      "Please confirm you wish to override current settings",
    GlobalPresetWarningMessage:
      "This will update all existing permissions settings.",
    GroupPermissions: "Groepsrechten",
    Permissions: "machtigingen",
    ResetPassword: "Wachtwoord opnieuw instellen",
    ResetPasswords: "Wachtwoorden opnieuw instellen",
    ResetTOTPConfig: "Resetten 2FA configuratie",
    SecurityPolicies: "Beveiligingsbeleid",
    SecurityPolicySettings: {
      AllowPasswordRepeat: "Sta wachtwoordherhaling toe tijdens expriy reset",
      Basedigits: "Basis 10 cijfers (0-9)",
      Disabled: "Uitgeschakeld",
      Enabled: "Ingeschakeld",
      Lowercaseletters: "Kleine letters",
      MinimumRequired: "Minimaal drie vereist",
      Minutes: "notulen",
      NotificationExpiryDays: "Kennisgevingen verlopen (dagen)",
      NotificationExpirySaved: "Melding vervaldatum opgeslagen",
      PasswordExpiry: "Wachtwoord verloopt (dagen)",
      PasswordExpiryPolicy: "Wachtwoord verloopt beleid",
      PasswordLength: "Wachtwoordlengte (tekens)",
      PasswordLockoutAttempts: "Wachtwoordvergrendeling (pogingen)",
      PasswordSettings: "Wachtwoord instellingen",
      PreventCompromised: "Controleer op gecompromitteerd",
      PreventPIIData: "Voorkom persoonsgegevens",
      SelectaTime: "Selecteer een tijd",
      SessionTimeout: "Time-out sessie",
      SessionTimeoutSaved: "Sessietime-out is opgeslagen",
      Specialcharacters: "Speciale tekens",
      TwoFA: "Twee-factor-authenticatie",
      TwoFAOptions: {
        Disabled: "Uitgeschakeld",
        Email: "Ingeschakeld - E-mail code naar gebruiker",
        TOTP: "Ingeschakeld - Eenmalig wachtwoord via Authenticator-app",
      },
      TwoFACodeLifespan: "Twee-factorenauthenticatiecode Levensduur (minuten)",
      Unicodecharacters: "Unicode-tekens",
      Update2FAConfig: "Twee-factorenauthenticatieconfiguratie is bijgewerkt.",
      Update2FALifespan:
        "Twee-factor-authenticatiecode Levensduur is bijgewerkt.",
      UpdatedPasswordExpiryPolicy:
        "Het beleid voor het verlopen van wachtwoorden is bijgewerkt.",
      Uppercaseletters: "Hoofdletters",
    },
    SelectGlobalPreset: "Please select a global preset",
    ThisGroupContainsUsers: "Can not delete the group because it has users",
    UpdatePreset: "Update Presets",
    UserPermissions: "Gebruikersrechten",
    ViewRoles: "View Roles",
    Users: {
      AddUserToTheGroup: "Voeg een gebruiker toe aan de groep",
      AreYouSuredelete: "Weet je zeker dat je wilt verwijderen",
      DeleteUser: "Verwijder gebruiker",
      EditDeleteGroup: "Groep bewerken of verwijderen",
      EditDeleteUser: "Gebruiker bewerken of verwijderen",
      EditGroup: "Groep bewerken",
      LockUser: "Lock User",
      NoUsersSelected: "Geen gebruikers geselecteerd",
      Reset2FAConfigurationConfirm: "Bevestig uw verzoek",
      Reset2FAConfigurationConfirmation:
        "Weet u zeker dat u de 2FA-configuratie van deze gebruiker wilt resetten? De gebruiker wordt bij de volgende aanmelding gevraagd om zijn authenticatietoepassing op zijn mobiele apparaat opnieuw te configureren.",
      Reset2FAConfigurationSuccess: "2FA Configuratie reset succesvol",
      ResetGroupPasswordConfirmation:
        "U wilt een wachtwoordreset forceren voor de volgende groep:",
      ResetGroupPasswordSuccess: "Wachtwoord opnieuw ingesteld",
      ResetPasswordConfirm: "Bevestig uw verzoek",
      ResetPasswordConfirmation:
        "U wilt een wachtwoordreset forceren voor de volgende gebruiker:",
      ResetPasswordSuccess: "Wachtwoord opnieuw ingesteld",
      ThisUser: "deze gebruiker",
    },
    ViewNames: {
      ACCOUNTS: "Rekeningen",
      ADMIN: "Beheerder",
      BILLING: "Gebruik",
      DASHBOARD: "Dashboard",
      DOCUMENTTYPE: "Documenttypen",
      DOCUMENTUPLOAD: "Document uploaden",
      METADATAKEY: "Metadatasleutels",
      REASON: "Redenen",
      REPORTS: "Rapporten",
      RETENTION: "Behoud",
      ROLES: "Rollen",
      SITE_PREFERENCES: "Website voorkeuren",
      SITEMANAGEMENT: "Mapbeheer",
      VIEW_DOCUPLOADPPI: "Overeenkomende gegevens uploaden",
      WORKFLOW: "Werkstroom",
      ANNOUNCEMENTS: "Aankondigingen",
    },
  },
  AccountPermissions: {
    EnterNewPasswordFor: "Voer nieuw wachtwoord in voor",
    Modify: "Wijzigen",
    Operations: "Operaties",
    ResetPassword: "Reset wachtwoord",
    SelectAFolder: "Selecteer een map",
    View: "Uitzicht",
  },
  Accounts: "Accounts",
  Action: "Actie",
  ActiveAnnouncements: " actieve aankondigingen",
  ActiveUsers: "Actief Gebruiker Totaal",
  Add: "Toevoegen",
  AddACondition: "Voeg een voorwaarde toe",
  AddANewMetadataKey: "Voeg een nieuwe metadatasleutel toe",
  AddChild: "Kind toevoegen",
  AddComment: "Voeg opmerking toe",
  AddDocument: "Document toevoegen",
  AddDocumentType: "Documenttype toevoegen",
  AddedComment: "Reactie toegevoegd",
  AddNewFolder: "Nieuwe map toevoegen",
  AdditionalInformation: "Additional Information",
  AdditionalInformationPlaceHolder:
    "Please provide any additional information you want added to the email here.",
  AdditionalOptions: {
    AdditionalOptions: "Toegevoegde opties",
    Download: "Documentopmerkingen opnemen in gedownload document",
    Email: "Documentopmerkingen opnemen in gemaild document",
    Print: "Documentopmerkingen opnemen in afgedrukt document",
  },
  AddNewTextValue: "Voeg nieuwe tekstwaarde toe",
  AddParentFolder: "Ouder toevoegen",
  AdminPages: "Beheerpagina's",
  Alias: "Alias",
  AllMetadata: "Alle metagegevens",
  Alpha: "Alfa",
  AlreadyExists: "bestaat al",
  Announcements: "Aankondigingen",
  Announcement: {
    BroadcastEndDate: "Einddatum",
    BroadcastStartDate: "Begin datum",
    Create: "Maak een nieuwe aankondiging",
    DeletionConfirmation: "Weet je zeker dat je wilt verwijderen",
    Empty: "Er zijn momenteel geen aankondigingen",
    Expired: "Verlopen",
    Expires: "Verloopt",
    Message: "Inhoud",
    Pending: "Begint",
    Title: "Titel",
    Save: "Redden",
    SeverityLevel: "Ernst",
    Severity: {
      Important: "Belangrijk",
      Warning: "Waarschuwing",
      Information: "Informatie",
    },
  },
  Apply: "Aankondiging",
  AreYouSureYouWantReset: "Are you sure you want to reset",
  AssignUpload: "Wijs en upload",
  AssociatedMetadata: "Bijbehorende metagegevens",
  AtleastLowercase: "Op zijn minst een kleine letter",
  AtleastOneNum: "Ten minste één nummer",
  AtleastSpecialChar: "Minstens een speciaal karakter",
  AtleastUnicodeChar: "Ten minste één Unicode-teken",
  AtleastUppercase: "Ten minste een hoofdletter",
  AttachFile: "Voeg een bestand toe",
  Back: "terug",
  Background: "Achtergrond",
  BetweenChars: (min, max) => `Tussen ${min} - ${max} tekens`,
  Billing: "Gebruik",
  Bookmark: "Bladwijzer",
  BookmarkClassification: {
    0: "Personal",
    1: "Published / Shared",
  },
  Bookmarks: "Bladwijzers",
  BookmarkTypes: {
    Personal: "Persoonlijk",
    SharedPublished: "Gepubliceerd / Gedeeld",
  },
  Boolean: "Ja nee",
  BothPasswordsIdentical: "Beide wachtwoorden moeten identiek zijn",
  Browse: "Blader",
  BucketSize: "Opslag totaal (GB)",
  BulkUploadTitle: "Massa upload",
  Cancel: "Annuleer",
  CancelPasswordReset: "Annuleren Wachtwoord resetten",
  CancelReset: "Annuleren Wachtwoord resetten",
  CannotCreateThisFolder: "Kan deze map niet maken",
  CardView: "Kaartweergave",
  ChangePassword: "Wachtwoord wijzigen",
  Characters: "karakters",
  Choose: "Kiezen",
  ChooseDate: "Kies datum",
  ChooseDocType: "Kies documenttype",
  ChosenDocType: "Geselecteerd documenttype",
  ChooseDocumentType: "Kies Documenttype",
  ChooseLocation: "Kies een locatie",
  ChosenLocation: "Geselecteerde map",
  Clear: "Doorzichtig",
  ClearAll: "Wis alles",
  Click: "Klik",
  ClickingContinue: "Clicking continue below will redirect you",
  ClientForms: {
    ClientOrder: {
      Fields: {
        accountNumber: "Rekeningnummer",
        additionalInformation: "Extra informatie",
        addressLine1: "Adresregel 1",
        addressLine2: "Adresregel 2",
        addressLine3: "Adresregel 3",
        authorisedBy: "Geautoriseerd door",
        barcode: "Streepjescode",
        company: "Bedrijf",
        contactName: "Contactnaam",
        department: "Afdeling",
        destroyDate: "Vernietigingsdatum",
        driverInstructions: "Stuurprogramma-instructies",
        email: "Email",
        name: "Contact Name",
        phone: "Telefoon",
        postCode: "Post Code",
        size: "Maat",
        uniqueId: "Uniek Id",
      },
      InfoMessage:
        "Bedankt voor het indienen van uw formulier. De onderstaande informatie is succesvol verzonden naar OASIS Group.",
      SubmitForm: "Verzenden",
      Title: "Klantorder",
      ValidationMessages: {
        accountNumber: "Rekeningnummer is benodigd.",
        addressLine1: "Adresregel 1 is benodigd.",
        addressLine2: "Adresregel 2 is benodigd.",
        barcode: "Streepjescode is benodigd.",
        company: "Bedrijf is benodigd.",
        contactName: "Contactnaam is benodigd.",
        email: "Email is benodigd.",
        emailFormat: "E-mail moet een geldige e-mail zijn.",
        messageMaxLength10: "Maximale limiet met teken (10)",
        messageMaxLength20: "Maximale limiet met teken (20)",
        messageMaxLength40: "Maximale limiet met teken (40)",
        messageMaxLength80: "Maximale limiet met teken (80)",
        name: "Contact name is required.",
        phone: "Telefoon is benodigd.",
        postCode: "Post code is benodigd.",
      },
    },
    ContactClientCare: {
      Fields: {
        description: "Beschrijving",
        email: "Email",
        reason: "Reden",
      },
      InfoMessage:
        "Bedankt voor het verzenden van uw formulier. Onderstaande informatie is succesvol verzonden naar OASIS Group.",
      Title: "Neem contact op met Klantenservice",
      Reasons: [
        "Ik wil een nieuw artikel naar de opslag sturen of een artikel uit de opslag laten bezorgen.",
        "Ik wil mijn activagegevens die momenteel op uw systemen zijn opgeslagen, bijwerken.",
        "Ik wil regelen dat een van mijn bezittingen wordt vernietigd.",
        "Ik wil graag een veilige vernietiging regelen.",
        "Ik wil graag praten over het instellen of aanpassen van een geplande of terugkerende bestelling.",
        "Ik wil verbruiksartikelen of materialen kopen van de OASIS Group.",
        "Ik wil een bestelling opvragen die ik al heb geplaatst.",
        "Ik heb een vraag over mijn contract.",
        "Ik wil graag aanvullende training organiseren over het ClientHub-systeem.",
        "Ik wil graag een nieuwe locatie/kantoor/site registreren bij OASIS Group.",
        "Ik wil graag een rapport op maat aanvragen.",
        "Ik wil graag de afdeling Credit Control spreken.",
        "We overwegen om OASIS Group te verlaten en willen het proces graag bespreken.",
        "Ik wil graag een kopie van een historische factuur opvragen.",
        "Ik wil graag de factureringsafdeling spreken.",
        "Ik heb een vraag over de prijsstelling.",
        "Ik wil graag extra gebruikers toevoegen aan ons OASIS Group-account.",
      ],
      SubmitForm: "Formulier verzenden",
      ValidationMessages: {
        description: "Beschrijving is vereist.",
        email: "E-mail is vereist.",
        emailFormat: "E-mail moet een geldig e-mailadres zijn.",
        messageMaxLength80: "Maximum character limit met (80)",
        reason: "Reden is vereist.",
      },
    },
    ReturnToClientForms: "Keer terug naar clientformulieren",
  },
  ClientHub: {
    ClientAccount: "Klantaccount",
    ClientAccountDetails: {
      AccountName: "Accountnaam",
      AccountCode: "Accountcode klant",
      AccountEmail: "E-mailaccount",
      Industry: "Industrie",
      MailingCity: "Post stad",
      MailingCountry: "Land van verzending",
      MailingPostCode: "Postcode",
      MailingStreet: "Poststraat",
      MailingStateProvince: "Post staat / Provincie",
      ReturnToClientAccount: "Keer terug naar klantaccount",
      Region: "Regio",
      SaveAccountDetails: "Sla accountgegevens op",
      TelephoneNumber: "Telefoon nummer",
      ThankYouMessage:
        "Bedankt voor het bijwerken van uw accountgegevens. De onderstaande informatie is succesvol opgeslagen.",
      Type: "Type",
    },
    ClientFormsTitle: "Klantformulieren",
    ClientOrder: "Klantbestelling",
    ContactClientCare: "Neem contact op met Klantenservice",
    ContentsManifest: "Inhoudsmanifest",
    Customer: "Klant",
    CustomFields: "Aangepaste velden",
    Dashboard: "Dashboard",
    DepartmentName: "Afdelingsnaam",
    DestructionOverview: "Vernietigingsoverzicht: afgelopen 6 maanden",
    Digital: "Digitaal",
    DigitalStorage: "Digitale opslag",
    DigitalStorageUsage: "Gebruik van digitale opslag",
    DownloadResults: "Resultaten downloaden",
    FormContent: {
      BriefDescriptionOfAnyActionTakenSinceDiscovery:
        "Korte beschrijving van elke actie die is ondernomen sinds de ontdekking",
      BriefDescriptionOfAnyActionTakenSinceDiscoveryPlaceholder:
        "Voer een beschrijving in van de ondernomen acties",
      BriefDescriptionOfBreach: "Korte beschrijving van de inbreuk:",
      BriefDescriptionOfBreachPlaceholder:
        "Voer alle belangrijke informatie over de mogelijke inbreuk in.",
      ContactEmailOfBreachReporter: "Contact e-mail van Breach Reporter",
      ContactEmailOfIncidentOwner:
        "Contact e-mailadres van de eigenaar van het incident",
      ContactNoOfBreachReporter: "Contactnummer van Breach Reporter",
      ContactNoOfIncidentOwner:
        "Contactnummer van de eigenaar van het incident",
      DateOfBreach: "Datum van Inbreuk",
      DateOfDiscovery: "Datum van ontdekking",
      LocationAffected: "Getroffen locatie",
      LocationAffectedPlaceholder:
        "Voer informatie in over de bekende getroffen locaties.",
      NameOfBreachReporter: "Naam van de inbreukrapporter",
      NameOfIncidentOwner: "Naam van de eigenaar van het incident",
      NumberOfAffectedSubjects:
        "Aantal getroffen proefpersonen - indien bekend",
      NumberOfAffectedSubjectsPlaceholder:
        "Voer een korte beschrijving van onderwerpen in - indien bekend",
      SubmitReport: "Rapport indienen",
      TypeOfBreach: "Type inbreuk",
    },
    InternalBoxReference: "Interne doosreferentie",
    InventoryTotals: "Voorraadtotalen",
    IssueGettingDataLineOne:
      "Er is een probleem opgetreden bij het ophalen van uw gegevens.",
    IssueGettingDataLineTwo:
      "Neem contact op met Client Care als dit bericht aanhoudt na het vernieuwen",
    ItemCode: "Artikelcode",
    ItemTypeByStatus: "Itemtype op status",
    NoDataResult: "Geen gegevensresultaten",
    PendingDestruction: "In afwachting van vernietiging",
    Physical: "Fysiek",
    PhysicalRecordBreakdown: "Uitsplitsing van fysieke records",
    PhysicalStorage: "Fysieke opslag",
    ReportBreach: "Inbreuk melden",
    Reports: "Rapporten",
    SearchOptions: "Zoek opties",
    SortBy: "Sorteer op",
    Status: "Toestand",
    StorageSearch: "Opslag zoeken",
    ViewInOmnidox: "Bekijken in Omnidox",
    ViewOnOmnidox: "Uitzicht op Omnidox",
    WorkOrderSubmission: "Indiening werkorder",
    WorkOrderType: "Type werkorder: laatste 6 maanden",
    Year: "Jaar",
  },
  Close: "Sluiten",
  CollapseAll: "Collapse All",
  ComingSoon: "Binnenkort Beschikbaar",
  Comment: "Commentaar",
  Comments: "Comments",
  Compartment: "Gedeelte",
  CompartmentsList: "Compartimentenlijst",
  Condition: "Staat",
  ConfigureDisplayAmount: "Configureer de weergavehoeveelheid",
  Confirm: "Bevestigen",
  ConfirmNewPassword: "Bevestig nieuw wachtwoord",
  ConfirmOldPassword: "Bevestig oud wachtwoord",
  ContactUs: "Neem contact op",
  Continue: "Continue",
  ContinueTo: "Ga door naar",
  CookieConsent:
    "Door deze applicatie te gebruiken stemt u in met ons gebruik van cookies in overeenstemming met ons Cookiebeleid",
  Create: "Creëren",
  CreateAFolder: "Maak een map aan",
  CreateChild: "Maak een kind",
  CreateChildFolderIn: "Maak een onderliggende map aan",
  CreateDocumentType: "Maak documenttype aan",
  CreateFolder: "Map aanmaken",
  CreateGroups: "Maak groepen",
  CreateUsers: "Gebruikers maken",
  Dashboard: "Dashboard",
  DataTypeHere: "Datatype hier",
  Date: "Datum",
  Day: "Dag",
  Days: "Dagen",
  Decimal: "Decimale",
  Delete: "Verwijder",
  DeleteComment: "Verwijder deze reactie?",
  DeleteConfirm: "Confirm Deletion",
  DeleteData: "Document verwijderen",
  DeletedDocument: "Document verwijderd",
  DeleteFolder: "Verwijder map",
  DeleteInfoMessage: "These records will be removed in 24hrs",
  DeleteNode: "Verwijder deze knoop",
  DeleteRecords: "Delete Records",
  Description: "Omschrijving",
  DeselectAll: "Deselecteer alles",
  Disabled: "Uitgeschakeld",
  Document: "Document",
  DocumentActivityHistory: "Documentactiviteitsgeschiedenis",
  DocumentExplorer: "Documentverkenner",
  DocumentHistoryHeaders: {
    AddedComment: "Reactie toegevoegd",
    AddedMetadata: "Metadata toegevoegd",
    ArchivedDocument: "Gemarkeerd voor permanente opslag",
    ConvertedAndDownloadedDocument: "Geconverteerd en gedownload document",
    DeletedComment: "Verwijderde reactie",
    DeletedDocument: "Verwijderd document",
    DocumentMarkedForDestruction: "Document gemarkeerd voor vernietiging",
    DocumentReadiedForRetention:
      "Document gekwalificeerd voor retentiebeoordeling",
    DownloadedDocument: "Gedownload document",
    DownloadedDocumentMetadata: "Gedownloade documentmetagegevens",
    EmailedDocument: "Gemaild document",
    MatchData: "Overeenkomende gegevens",
    MergedAndDownloadedDocument: "Samengevoegd en gedownload document",
    MovedDocument: "Verplaatst document",
    PlacedDocumentBackInRetentionReview:
      "Teruggestuurd voor retentiebeoordeling",
    PrintedDocument: "Afgedrukt document",
    RestoredDocument: "Hersteld uit Prullenbak",
    RetentionReviewPostponed: "Retentie Review uitgesteld tot ",
    UnMatchData: "Ongeëvenaarde gegevens",
    UpdatedComment: "Bijgewerkte opmerking",
    UpdatedMetadata: "Bijgewerkte metagegevens",
    UploadedDocument: "Geüploade document",
    UpsertCustomerMetadata: "Metadata van klanten upsert",
    ViewedDocument: "Bekeken document",
  },
  DocumentId: "Document ID",
  DocumentIdentifier: "Doc-ID",
  DocumentName: "Document Naam",
  DocumentOpened: "Document geopend",
  DocumentPrinted: "Document afgedrukt",
  Documents: "Type document",
  DocumentType: "Type Document",
  DocumentTypeDeleteConfirmMessage: "Please confirm you wish to delete",
  DocumentTypeList: "Lijst met documenttypen",
  DocumentTypeName: "Naam documenttype",
  DocumentTypes: "Documenttypen",
  DocumentUpload: "Document uploaden",
  DocumentView: "Documentweergave",
  Download: "Downloaden",
  Downloading: "Downloaden...",
  DownloadOptions: "Download opties",
  DownloadOptionValues: {
    ConvertToPdfAndZip: "Converteren naar PDF en downloaden als Zip",
    StandardDownload: "Downloaden",
    DownloadMetadataAsCSV: "Metadata downloaden als CSV",
  },
  DownloadUserDetailsAsCSV: "Download Gebruikersgegevens als CSV",
  DropItHot: "Zet je bestanden hier neer!",
  DropZoneInitText: "Sleep uw bestanden hiernaartoe om ze te uploaden",
  Edit: "Bewerk",
  EditBookmark: "Bladwijzer bewerken",
  EditDeleteUsers: "Gebruikers bewerken of verwijderen",
  EditDocument: "Document bewerken",
  EditFolder: "Map bewerken",
  EditMetadataKey: "Bewerk metadatasleutel",
  Email: "E-mail",
  EmailAddress: "E-mailadres",
  EndDate: "Einddatum",
  EndDateBeforeStartDateError:
    "De einddatum ligt voor de startdatum, er konden geen resultaten worden gevonden",
  EmailDestinations: "Email Destination(s)",
  EmailDestinationsPlaceHolder: "first@mail.com ; second@mail.com ...",
  EmailSentMessage: "De email is verzonden.",
  EmailUnsentMessage:
    "E-mail kon niet worden verzonden omdat het bestand dat u probeert te verzenden te groot is. Probeer het opnieuw met een bestand dat kleiner is dan 15 MB.",
  EnterEmailAddress: "Vul email adres in",
  EnterFolderName: "Voer mapnaam in",
  EnterNewPassword: "Voer nieuw wachtwoord in",
  EnterOldPassword: "Voer oud wachtwoord in",
  EnterTemporaryPassword: "Voer een tijdelijk wachtwoord in",
  ErrorDocumentView:
    "Er is een fout opgetreden bij het ophalen van Documentweergave.",
  ExpandAll: "Expand All",
  Expires: "Verloopt",
  ExportButton: "Exporteren",
  ExportToCsv: "Exporteren naar CSV",
  ExporttoCSV: "Export to CSV",
  FieldType: "Veld soort",
  File: "Bestand",
  Filename: "Bestandsnaam",
  FilePreviewErrorForBigFile: "File too large to preview",
  Files: "Bestanden",
  FilesSuccessfullyUploaded: " succesvol geüpload",
  FileTooLargePart1: "Bestand overschrijdt de limiet van ",
  FileTooLargePart2: " MB",
  Filters: "Filters",
  FirstSelectDocumentType: "Selecteer eerst een documenttype",
  Folder: "Folder",
  FolderAndDocTypePermissionError:
    "U hebt map- en documenttype-machtigingen nodig.",
  FolderDeleteConfirmMessage: "Please confirm you wish to delete",
  FolderHierarchyTitle: "Maphiërarchie",
  FolderID: "Map-ID",
  FolderName: "Naam van de map",
  Folders: "Folders",
  FolderStructure: "Mapstructuur",
  FolderUploadSuccesMessage:
    "Bulk Folder Upload-bestand is succesvol geüpload voor verwerking",
  FooterCopyright: "© " + new Date().getFullYear() + " OASIS Group",
  ForgotPassword: "Wachtwoord vergeten",
  ForgotPasswordModalTitle: "Taking you to OASIS Bridge",
  Forms: {
    AddGroup: "Groep toevoegen",
    AddUser: "Voeg gebruiker toe",
    Department: "Afdeling",
    FirstName: "Voornaam",
    GroupName: "Groepsnaam",
    HasBeenCreated: "Is gemaakt",
    LastLogin: "Laatste aanmelding",
    Location: "Plaats",
    Mobile: "Mobiel",
    MobileNumber: "Mobiele nummer",
    Surname: "Achternaam",
  },
  GetBackShortly: "We komen spoedig bij u terug",
  GiveNewName: "Geef een nieuwe naam",
  GlobalSettings: "Algemene instellingen",
  Group: "Groep",
  Groups: "Groepen",
  GroupAlreadyExists: "Group already exists",
  GroupNameIsRequired: "Group name is required",
  Help: "Helpen",
  Here: "hier",
  Hidden: "Verborgen",
  Hour: "Uur",
  IsClientMetadata: "Komt overeen met metagegevens",
  IsDeleted: "Is verwijderd",
  IsSaved: "Is opgeslagen",
  Language: "Taal",
  LastModified: "Laatst gewijzigd",
  LetsTakeStep: "Laten we een stap zetten",
  Licenses: "Licenties",
  LicenseHome: "Licentie Thuis",
  LinkType: "Type koppeling",
  List: "Lijst",
  Loading: "Bezig met laden",
  LoadingDirectories: "Mappen laden...",
  Locked: "Op slot",
  Login: "Log in",
  LoginEmailAddressHint: "Voer uw gebruikersnaam of e-mailadres in",
  LoginErrorMessage: "Inlogpoging is mislukt",
  Logo: "Logo",
  LooksLikeErrorOccurred: "Het lijkt erop dat er een fout is opgetreden!",
  MarkDocumentsForDestruction: "Mark Documents for Destruction",
  markDocumentsForDestruction: "Mark for Permanent Deletion",
  MarkDocumentsrPermanentStorage: "Mark Documents for Permanent Storage",
  MarkedForPermanentDeletion: "Marked for Permanent Deletion",
  MarkForIndefiniteStorage: "Markering voor permanente opslag",
  Match: "Match",
  MatchData: "Match Data",
  MatchDocument: "Match document",
  Matched: "Op elkaar afgestemd",
  MatchedData: "Overeenkomende gegevens",
  MatchingContent: "Bijpassende inhoud",
  MatchResults: "Match resultaten",
  Merge: "Samenvoegen",
  Message: "Bericht",
  MessagePermanentlyDelete: "Please confirm the following",
  Metadata: "Metadata",
  MetadataDataType: "Data Type",
  MetadataDatekey: "Metadata date key",
  MetadataDeleteConfirmMessage: "Please confirm you wish to delete",
  MetadataFilters: "Metadata Filters",
  MetadataKeys: "Metagegevenssleutels",
  MetadataKeyDeleted: "Metadatasleutel succesvol verwijderd",
  MetadataKeyLockedForEditing: "is vergrendeld voor bewerking",
  MetadataKeysList: "Lijst met metatatasleutels",
  MetadataList: "Lijst met metagegevens",
  MetadataMandatory: "Is deze metadata verplicht?",
  MetadataName: "Metadata naam",
  MetadataPrioritiesAreUpdated: "Metadata priorities are updated",
  MinutesAgo: "minuten geleden",
  Mobile: "Mobiel",
  Month: "Maand",
  MonthNames: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  Months: "Maanden",
  MoveFolder: "Move Folder",
  MultiDocuments: "documenten",
  MyDashboard: "Mijn Dashboard",
  MyDocuments: "Mijn Documenten",
  Name: "Naam",
  Never: "Nooit",
  New: "Nieuw",
  NewAction: "Nieuwe Actie",
  NewCommentAdded: "Nieuwe opmerking is toegevoegd",
  NewCondition: "Nieuwe Conditie",
  NewFolder: "New folder",
  No: "Nee",
  NoDocuments: "Geen Documenten",
  NoDocumentsAvailable: "Er zijn momenteel geen documenten beschikbaar",
  NoDocumentsFoundInCurrentLocation:
    "Er zijn geen documenten gevonden op de huidige locatie.",
  NoDocumentTypes: "Geen documenttypen",
  NoMetadataDatekeys: "Geen metadata-datumsleutels",
  NoNotificaions: "U heeft geen meldingen",
  NoOfActiveDocuments: "Vermelding Totaal",
  NoResultForRetention:
    "No data result for this selection. Please try enter other values",
  NoResultsForSelection:
    "Geen gegevensresultaat voor deze selectie. Probeer a.u.b. anders in te voeren",
  NotAccepted: "Bestandstype niet geaccepteerd, sorry!",
  Notifications: "Meldingen",
  NoUsersToShow: "Geen gebruikers om te tonen...",
  Number: "Aantal",
  OfficeDocTooLargeToPreview:
    "Sorry, we kunnen Microsoft Office-documenten niet meer dan 20MB weergeven!",
  OfficeDocTooLargeToPreviewDownloadInstead:
    "Download dit document in plaats daarvan.",
  Omnidox: "Omnidox",
  OnTheLeft: "aan de linkerkant om documenten te vinden",
  OnTheRight:
    "aan de rechterkant om een ​​document te selecteren om te bekijken.",
  OpenedDocument: "Geopend document",
  Operand: "Operand",
  Or: "of",
  OtherData: "Andere gegevens",
  Others: "Others",
  Password: "Wachtwoord",
  PasswordConfirm: "Bevestig wachtwoord",
  PasswordDosentExist: "Deze e-mail bestaat niet in ons systeem.",
  PasswordInclude: "Wachtwoord moet bevatten:",
  PasswordMustInclude: "Wachtwoord moet bevatten",
  PasswordProtect: "Wachtwoord beveiligen?",
  PasswordReset: "Wachtwoord reset",
  PermGroups: {
    Archive: "Archive",
    Comments: "Comments",
    Delete: "Delete",
    Document: "Document",
    DocumentMetadata: "Document en metadata",
    Documents: "Documenten",
    Download: "Download",
    Email: "Email",
    HardDelete: "Hard Delete",
    History: "Geschiedenis",
    Import: "Importeren",
    LineData: "Lijngegevens",
    Mark: "Mark",
    Match: "Match",
    Move: "verhuizing",
    MoveDocumentTo: "Verplaats het document naar",
    MoveDocumentsTo: "Documenten verplaatsen naar",
    Print: "Afdrukken",
    Restore: "Restore",
    Revive: "Revive",
    Upload: "Uploaden",
    ViewAudit: "View Audit",
  },
  PermissionUpdate: "Group permissions are updated",
  PhysicalSearch: {
    Filters: {
      customerFilters: "Cliënt",
      departmentFilters: "Afdeling",
      fbufIlters: "FBU",
      itemTypeFilters: "Type d'élément",
      statusFilters: "Toestand",
    },
  },
  PleaseClickForgotPassword:
    "Please click 'Forgot Password' at the top right of the page to reset your password.",
  PleaseSelect: "Selecteer alstublieft",
  PleaseSelectDataType: "Selecteer Gegevenstype",
  PleaseWait: "Een ogenblik geduld...",
  Possible: "mogelijk",
  PostponeDocumentForRetentionReview:
    "Document voor retentiebeoordeling uitstellen",
  PostponeRetentionReview: "Retentiebeoordeling uitstellen",
  PPIFilesSuccessfullyQueued:
    " bestanden verzonden voor verwerking. U krijgt een melding wanneer deze klaar is.",
  PPIFileSuccessfullyQueued:
    " bestand verzonden voor verwerking. U krijgt een melding wanneer deze klaar is.",
  PreparingFilesForDownload: "Bestand(en) voorbereiden om te downloaden",
  PreparingFilesForPrinting: "Bestand(en) voorbereiden voor afdrukken",
  PreparingFilesForEmailing: "Bestand(en) voorbereiden voor e-mailen",
  PrintDocument: "Print Document",
  Printing: "Afdrukken...",
  PrivacyPolicy: "Privacybeleid",
  Profile: "Profiel",
  Published: "Gepubliceerd",
  PublicallyVisible: "Openbaar commentaar",
  PrivatelyVisible: "Privé commentaar",
  Reasons: {
    AddReason: "Reden toevoegen",
    DocumentOperations: "Documentbewerkingen",
    EditReason: "Reden bewerken",
    ExactMatch: "Exacte",
    Includes: "Inclusief",
    IsMandatory: "Is verplicht",
    LinkedOperations: "Gekoppelde bewerkingen",
    Reason: "Reden",
    ReasonName: "Reden naam",
    Reasons: "Redenen",
    ViewAllReasons: "Bekijk alle redenen",
    YouHaveNoReasons: "Je hebt nog geen redenen",
  },
  RecentlyUploaded: "Onlangs geüpload",
  RecyclingBin: {
    Title: "Prullenbak",
  },
  RedirectedToOASISBridge: "You are being redirected to OASIS Bridge.",
  RemoveSortKey: "Sorteersleutel verwijderen",
  Remove: "Remove",
  Rename: "Rename",
  RepeatExpiredPasswordNotAllowed:
    "Het herhalen van een verlopen wachtwoord is niet toegestaan",
  Reports: {
    ActivityOfAuthorisedUsersWidget:
      "Activiteit van geautoriseerde gebruikers voor een klant",
    ReportOfCompletedWorkOrderWidget:
      "Voltooide werkordertransacties per servicecode",
    ReportOfExpiredItemsReadyForDestructionWidget:
      "Vervaldatum van de container binnen het geselecteerde datumbereik",
    ReportOfFileAndItemRetrievalWidget:
      "Ophalen van bestanden/items door klant gesorteerd op",
    ReportOfInventoryStatusWidget: "Overzichtsrapport voorraadstatus",
    ReportOfItemsWithUpcapturedDataWidget: "Items zonder beschrijving",
    ReportOfRateCards: "Tariefkaart",
  },
  Required: "Verplicht",
  Reset: "Reset",
  RestoreBtn: "Restore",
  RestoreRecords: "Restore Records",
  RestoreRecordsForReview: "Herstellen voor beoordeling",
  RestoreTitle: "Restore",
  Retention: {
    AddRule: "Regel toevoegen",
    CreateRetentionTitle: "Maak een documentbehoudregel",
    DeleteRuleConfirmMessage: "Weet je zeker dat je wilt verwijderen",
    DisableRetentionPostponement:
      "Uitstelmogelijkheid van documenten uitschakelen in Retentiecontrole",
    DocumentRetention: "Documentbehoud",
    Retention: "Behoud",
    RetentionDuration: "Retentieduur",
    RetentionLogic: "Bewaarlogica",
    RuleActive: "Regel actief",
    RuleActiveOption: "Is regel actief?",
    RuleInactive: "Regel inactief",
    RuleDescription: "Regelbeschrijving",
    RuleDescriptionPlaceholder: "Mijn nieuwe bewaarregel",
    RuleName: "Regelnaam",
    Save: "Instellingen opslaan",
    SelectPeriodOfTime: "Selecteer tijdsperiode",
    Tab1: "Documentbeoordeling",
    Tab2: "Gemarkeerd voor permanente verwijdering",
    Tab3: "Gemarkeerd voor permanente opslag",
    TimePeriod: "Tijdsperiode",
    UpdatedMessage: "is updated.",
  },
  RetentionReviewPostponeModalText1: "Document met ID ",
  RetentionReviewPostponeModalText2:
    " uitsluiten van verwerking van bewaarregels tot",
  RetentionReviewPostponeModalText3:
    "Nadat u op Toepassen hebt geklikt, wordt dit document teruggestuurd naar 'Mijn documenten'",
  RetentionRules: "Retention Rules",
  Role: "Rol",
  RoleFeatureAccessSaved: "Functietoegang bijgewerkt",
  ROLES: "Roles",
  Roles: {
    AddedRole: "Nieuwe rol is toegevoegd.",
    AddGroup: "Groep toevoegen",
    AddRole: "Rol toevoegen",
    AddToRole: "Toevoegen aan rol",
    AddUser: "Gebruiker toevoegen",
    Back: "Terug",
    DeleteRole: "Weet u zeker dat u wilt verwijderen",
    EditRole: "Instellingen opslaan",
    EditTab1: "Basisinstellingen",
    EditTab2: "Functietoegang",
    EditTab3: "Roltoewijzingen",
    GroupList: "Groepen",
    HeaderCreateRole: "Maak een rol",
    NewAssignment: "Nieuwe opdracht",
    NoGroupAssigned: "Er is geen groepsopdracht.",
    NoGroupForAssignmet: "Geen groepen.",
    NoUserAssigned: "Er is geen gebruikerstoewijzing.",
    NoUserForAssignmet: "Geen gebruikers.",
    RemoveAssignmet: "Verwijderen",
    RoleDesc: "Beschrijving",
    RoleList: "Huidige rollen",
    RoleName: "Rolnaam",
    UpdatedRole: "is bijgewerkt",
    UserList: "Gebruikers",
  },
  Save: "Opslaan",
  SaveBookmark: "Bewaar bladwijzer",
  SaveDocument: "Document opslaan",
  SaveToFolder: "Opslaan in map",
  Search: "Zoeken",
  SearchBin: "Search Bin",
  SearchDocs: "Zoek documenten",
  SearchDocumentRetention: "Search Document Retention",
  SearchFolders: "Search folders",
  SearchMarkedPermanentDeletion: "Search Marked for Permanent Deletion",
  SearchMarkedPermanentStorage: "Search Marked for Permanent Storage",
  SearchResult: "resultaat",
  SearchResults: "resultaten",
  SearchReturned: "teruggekeerd",
  SelectAll: "Selecteer alles",
  SelectCategory: "Selecteer een categorie",
  SelectDataType: "Selecteer gegevenstype",
  SelectDocumentType: "Selecteer Documenttype",
  SelectDownloadType: "Selecteer Downloadtype",
  Selected: "geselecteerd",
  SelectFile: "Selecteer bestand",
  SelectFileText: "Bulkupload van mappen via CSV",
  SelectMetadataDatekey: "Selecteer een datumsleutel voor metagegevens",
  SelectOptions: {
    GeneralEnquiry: "Algemeen onderzoek",
    ProductSupport: "Product ondersteuning",
    SuggestedImprovements: "Voorgestelde verbeteringen",
  },
  SelectWorkFlow: "Please select workflow",
  SelectYourFiles: "Selecteer uw bestanden",
  Send: "Send",
  SendEmailTitle: "Email your document",
  Settings: "Instellingen",
  SettingsRezMessage:
    "Omnidox-instellingen zijn niet toegankelijk met deze huidige resolutie. Gebruik een groter venster om door te gaan",
  ShowInFolder: "Weergeven in map",
  ShowOnList: "Show on Table View",
  SignIn: "Aanmelden",
  SignInWith: "Aanmelden met",
  SignOut: "Afmelden",
  SingleDocument: "document",
  SiteManagement: "Mapbeheer",
  SitePreferences: {
    DefaultSearchFilters: "Standaard zoekfilters",
    DefaultSearchFiltersLabels: {
      Comments: "Opmerkingen",
      Filename: "Bestandsnaam",
      MatchingData: "Overeenkomende gegevens",
      Metadata: "Metadata",
      OCR: "OCR",
    },
    DocumentSecurity: "Documentbeveiliging",
    DocumentSecurityLabels: {
      PasswordProtectBulkActionDownload:
        "Zorg ervoor dat downloads van bulkacties met een wachtwoord worden beveiligd",
      PasswordProtectBulkActionDownloadExplanation:
        "Wachtwoordbeveiliging voor het downloaden van bulkacties is door uw sitebeheerder ingesteld als een verplichte vereiste",
    },
    FolderInheritanceLabel:
      " De onderliggende map krijgt bij het maken dezelfde rechten als de directe bovenliggende map",
    Folders: "Mappen",
    MaxPaginationResults: "Resultaten per pagina",
    MaxSearchResults: "Maximale zoekresultaten",
    PDFLegacyMode: "PDF Legacy-modus",
    PDFLegacyModeLabels: {
      EnablePDFLegacyMode:
        "Schakel de pdf-legacy-modus in. Met de oude pdf-modus kunnen gebruikers de onderstaande functies omzeilen",
      PermissionsCircumvention:
        "- PDF-documenten alleen downloaden, afdrukken en e-mailen door gebruikers met de benodigde machtigingen",
      CapturingReasonsCircumvention:
        "- Vastleggen van redenen voor het downloaden, afdrukken en e-mailen van PDF-documenten",
      DocumentHistoryCircumvention:
        "- Het downloaden, afdrukken en e-mailen van PDF-documenten wordt geregistreerd in de documentgeschiedenis",
    },
    SaveSettings: "Instellingen opslaan",
    SearchResults: "Zoekresultaten",
    SearchResultLabels: {
      IncludeOcrSearchResultContext:
        "Voeg een fragment van relevante OCR-tekst toe die overeenkomt met de zoekterm van de gebruiker wanneer u Card View-resultatenweergave gebruikt",
    },
    SelectDropDownOption: "Kies een optie",
    Title: "Website voorkeuren",
  },
  SomethingWrong: "Er is iets fout gegaan",
  Sort: "Soort",
  SortBy: "Sort By",
  SortFolderWarning:
    "U staat op het punt uw mappenstructuur opnieuw te ordenen met behulp van de functie Alfabetisch sorteren op. Hiermee wordt alle aangepaste sortering verwijderd.",
  SortOrder: "Sorteervolgorde",
  Source: "Bron",
  StartDate: "Startdatum",
  StaySignedIn: "Blijf ingelogd",
  Subject: "Onderwerpen",
  Submit: "Voorleggen",
  SuccessUploaded: "Succesvol geüpload",
  TableView: "Tabelweergave",
  Telephone: "Telefoon",
  TellUsMore: "Klik hier om ons meer te vertellen",
  TempPasswordNotReused:
    "Tijdelijk wachtwoord mag niet opnieuw worden gebruikt",
  TermsConditions: "Voorwaarden",
  Text: "Tekst",
  Thankyou: "Dank je!",
  ThereAre: "Er zijn ",
  ThisDocumentContainsNoMetadata: "Dit document bevat geen metagegevens",
  ThisFolderContainsFolders:
    "Deze map bevat mappen, verwijder eerst de onderliggende mappen",
  ThisFolderIsEmpty: "Deze map is momenteel leeg",
  TimeOut:
    "Het achtergrondproces is verlopen en mislukt. Dit komt meestal omdat de gecombineerde grootte van de te downloaden bestanden te groot is.",
  Tip: "Tip",
  Title: "Titel",
  ToAddContent: "om inhoud toe te voegen",
  ToSafety: "naar veiligheid",
  Total: "TOTAL",
  TwoFAuth: {
    CancelLogin: "Annuleer inloggen",
    CodeLabelPromptEmail: "Voer de 6-cijferige code uit uw e-mail in",
    CodeLabelPromptTOTP: "Voer de 6-cijferige code van uw authenticator-app in",
    Confirm: "Bevestigen",
    MessageForEmailCode: "We hebben je een e-mail gestuurd met een code",
    MessageForTOTPCode: "Eenmalige wachtwoordverificatie",
    SidebarMenu: {
      ConfirmationHeader: "Configuratie resetten - Weet u het zeker?",
      FollowInstructions: "Volg de onderstaande instructies",
      EnterCode: "Voer de 6-cijferige code van uw apparaat in",
      Header: "Eenmalig wachtwoord",
      ManageSettings: "Beheer eenmalige wachtwoordinstellingen",
      QRCodeInstructions:
        "Scan deze QR-code met uw Authenticator-app. U ziet een 6-cijferige code verschijnen op uw apparaat",
      SecretKeyInstructions:
        "Als u de QR-code niet kunt scannen, voert u deze tekstcode handmatig in op uw mobiele apparaat",
      Success:
        "Twee Factor Authentication-instellingen zijn met succes opgeslagen en geverifieerd",
      WarningOne:
        "Als u op 'Doorgaan' klikt, wordt de bestaande configuratie verwijderd",
      WarningTwo:
        "U moet alle volgende stappen uitvoeren om toegang tot uw account te behouden",
      WarningThree:
        "Uw vorige configuratiecode is niet langer geldig, u moet een bestaande configuratie uit uw Authenticator-app verwijderen",
      WarningFour:
        "Als je niet alle stappen voltooit nadat je op 'Doorgaan' hebt geklikt, kun je niet inloggen en moet je een sitebeheerder vragen om je configuratie opnieuw in te stellen",
    },
  },
  Type: "Type",
  Unknown: "onbekend",
  UnauthorizedPage: "Met uw machtigingen kunt u deze pagina niet zien",
  undefined: "onbepaald",
  UnmatchData: "Niet-overeenkomende gegevens",
  UnsupportedFileSelection: "Unsupported file selected.",
  Updated: "Bijgewerkt",
  UpdatePriority: "Update Priority",
  UploadDocuments: "Documenten uploaden",
  UploadedBy: "Geupload door",
  UploadedDate: "Datum van uploaden",
  UploadFiles: "Upload bestanden",
  Uploading: "Bezig met uploaden...",
  UploadYourFiles: "Upload uw bestanden",
  User: "gebruiker",
  UserGroupsList: "Lijst met gebruikersgroepen",
  Username: "Gebruikersnaam",
  Users: "Gebruikers",
  UseThe: "Gebruik de",
  View: "View",
  ViewDocument: "Document bekijken",
  ViewNewEntries: "Bekijk nieuwe items",
  ViewOldEntries: "Bekijk oude items",
  ViewPer: "Bekijk per",
  Week: "Week",
  Weeks: "Weken",
  Welcome: "Welkom",
  WelcomeToDocuments: "Welkom bij mijn documenten",
  Workflow: {
    Triggers: {
      DocumentAssignedTo: "Document toegewezen aan",
      DocumentDeleted: "Document verwijderd",
      DocumentImported: "Document geïmporteerd",
      DocumentMoved: "Document verplaatst",
      DocumentStatusChanged: "Documentstatus gewijzigd",
      DocumentUploaded: "Document Geüpload",
      MetadataInserted: "Metagegevens ingevoegd",
      MetadataUpdated: "Metagegevens bijgewerkt",
    },
    WorkflowOperand: {
      Between: "Between",
      Contains: "Contains",
      Equal: "Equal",
      GreaterThan: "Greater Than",
      GreaterThanOrEqualTo: "Greater Than Or Equal To",
      LessThan: "Less Than",
      LessThanOrEqualTo: "Less Than Or Equal To",
      None: "None",
      NotEqual: "Not Equal",
    },
  },
  WorkflowList: "Werkstroomlijst",
  WorkflowTitle: "Workflow",
  Years: "Jaren",
  Yes: "Ja",
  YouHaveNoUsersYet: "U heeft nog geen gebruikers",
  YourActivityHistoryIsEmpty: "Uw bestandsgeschiedenis is leeg",
  YourFileHistoryIsEmpty: "Uw bestandsgeschiedenis is leeg",
  YourFiles: "uw bestanden",

  get Sidebar() {
    return {
      MyDocuments: this.MyDocuments,
      UploadDocuments: this.UploadDocuments,
      Settings: this.Settings,
      RecyclingBin: this.RecyclingBin.Title,
      DocumentRetention: this.Retention.DocumentRetention,
      Notifications: this.Notifications,
      ContactUs: this.ContactUs,
      Profile: this.Profile,

      Dashboard: this.Account.ViewNames.DASHBOARD,
      StorageSearch: "Opslag zoeken",
      Reports: "Rapporten",
      ClientForms: "Klantformulieren",
      ClientAccount: "Klantaccount",
    };
  },
};
